import { WebApiService } from '../../../plugins/webApiService'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import GetIconListRequest from '../../../projects/groups/i-service/model/setting-icon/GetIconListRequest';
import UpsertSettingIconRequest from '../../../projects/groups/i-service/model/setting-icon/UpsertSettingIconRequest';
import RemoveSettingIconRequest from '../../../projects/groups/i-service/model/setting-icon/RemoveSettingIconRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import GetIconListResponse from '../../../projects/groups/i-service/model/setting-icon/GetIconListResponse';
import UpsertSettingIconResponse from '../../../projects/groups/i-service/model/setting-icon/UpsertSettingIconResponse';
import RemoveSettingIconResponse from '../../../projects/groups/i-service/model/setting-icon/RemoveSettingIconResponse';

/**
 * * Сервис для управления иконками
 */
export default class SettingIconService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Получение списка иконок
	 */
	async GetIconList(request: GetIconListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'SettingIconService',
			Method: 'GetIconList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание/обновление цвета
	 */
	async UpsertSettingIcon(request: UpsertSettingIconRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'SettingIconService',
			Method: 'UpsertSettingIcon',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление цвета
	 */
	async RemoveSettingIcon(request: RemoveSettingIconRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'SettingIconService',
			Method: 'RemoveSettingIcon',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение списка иконок
	 */
	async getIconListAsync(request: GetIconListRequest): Promise<GetIconListResponse> {
		return new Promise<GetIconListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'SettingIconService',
				Method: 'GetIconList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetIconListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetIconListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание/обновление цвета
	 */
	async upsertSettingIconAsync(request: UpsertSettingIconRequest): Promise<UpsertSettingIconResponse> {
		return new Promise<UpsertSettingIconResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'SettingIconService',
				Method: 'UpsertSettingIcon',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UpsertSettingIconResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UpsertSettingIconResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление цвета
	 */
	async removeSettingIconAsync(request: RemoveSettingIconRequest): Promise<RemoveSettingIconResponse> {
		return new Promise<RemoveSettingIconResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'SettingIconService',
				Method: 'RemoveSettingIcon',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<RemoveSettingIconResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as RemoveSettingIconResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}